import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../languages/i18n';
import './Auth.scss';

import Text from '../../containers/Text';


const OTPGetCode = ({ email, code, setCode, error, isLoading, handleBack }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="content-wrapper">
      <div className={'input-wrapper'}>
        <span className='input-title'>
          <Text text={t('verification-code')} />
        </span>

        <div className={`otp-sent-info`}>
          <div>{t('code-sent-to')}</div>
          <div>{email}</div>
        </div>

        <input
          autoFocus
          required
          placeholder="000000"
          className={`otp-input ${error.active ? 'otp-input-error' : ''}`}
          type="text"
          name="code"
          value={code}
          onChange={(e) => setCode(e.target.value.trim())}
        />


        {error.active && (
          <div className="auth-error-box">
            <Text text={t(error.key)} />
          </div>
        )}

        <button
          className={`
        lng-button 
        submit-button 
      `}
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? <div className="spinner"></div> : t('verify-and-login')}
        </button>

        <button
          type="button"
          className={`
        lng-button 
        back-button 
      `}
          onClick={handleBack}
        >
          {t('back')}
        </button>

        {/* <div className="resend-code-wrapper">
          <span className="resend-link">
            <Text text={t('send-new-code')} />
          </span>
        </div> */}
      </div>
    </div>
  );
};

export { OTPGetCode };

